import { render, staticRenderFns } from "./PageMain.vue?vue&type=template&id=3e43a6ac&scoped=true&"
import script from "./PageMain.vue?vue&type=script&lang=ts&"
export * from "./PageMain.vue?vue&type=script&lang=ts&"
import style0 from "./PageMain.vue?vue&type=style&index=0&id=3e43a6ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e43a6ac",
  null
  
)

export default component.exports